var _defs, _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRole(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    width: 16,
    height: 16,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Role") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h32v32h-32z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m5.33 28q-1.1 0-1.88-0.78-0.78-0.79-0.78-1.89v-14.66q0-1.1 0.78-1.89 0.78-0.78 1.88-0.78h5.34v-2.67q0-1.1 0.78-1.88 0.78-0.78 1.88-0.78h5.34q1.1 0 1.88 0.78 0.78 0.78 0.78 1.88v2.67h5.34q1.1 0 1.88 0.78 0.78 0.79 0.78 1.89v14.66q0 1.1-0.78 1.89-0.78 0.78-1.88 0.78zm0-2.67h21.33v-14.66h-21.33zm8-17.34h5.33v-2.66h-5.33z"
  })))), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: #e4002b } \n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page 1",
    clipPath: "url(#cp1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask",
    clipPath: "url(#cp2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path 2",
    className: "s0",
    d: "m2.7 25.3h-2zm2.6-17.3v-2zm5.4 0v2h2v-2zm2.6-5.3v-2zm5.8 2.2c0.2 0.1 0.2 0.2 0.2 0.4h4c0-1.2-0.4-2.4-1.3-3.3zm2.2 3.2h-2v2h2zm5.8 2.2c0.1 0.1 0.2 0.2 0.2 0.4h4c0-1.2-0.5-2.4-1.4-3.3zm0 15.6c-0.2 0.2-0.3 0.2-0.5 0.2v4c1.3 0 2.4-0.4 3.3-1.3zm-21.8-0.5h-2v2h2zm21.3 0v2h2v-2zm0-14.7h2v-2h-2zm-21.3 0v-2h-2v2zm8-2.6h-2v2h2zm5.3 0v2h2v-2zm0-2.7h2v-2h-2zm-5.3 0v-2h-2v2zm-8 20.7c-0.2 0-0.3-0.1-0.5-0.2l-2.8 2.8c0.9 0.9 2 1.4 3.3 1.4zm-0.5-0.2c-0.1-0.2-0.2-0.3-0.2-0.5h-4c0.1 1.3 0.5 2.4 1.4 3.3zm-0.2-0.5v-14.6h-4v14.6zm0-14.6c0-0.2 0.1-0.4 0.2-0.5l-2.8-2.8c-0.9 0.9-1.4 2-1.4 3.3zm0.2-0.5c0.2-0.2 0.3-0.2 0.5-0.2v-4c-1.3 0-2.4 0.5-3.3 1.4zm0.5-0.2h5.3v-4h-5.3zm7.3-2v-2.7h-4v2.7zm0-2.7c0-0.2 0-0.3 0.2-0.5l-2.8-2.8c-0.9 0.9-1.4 2-1.4 3.3zm0.2-0.5c0.1-0.1 0.3-0.2 0.5-0.2v-4c-1.3 0-2.4 0.5-3.3 1.4zm0.4-0.2h5.4v-4h-5.4zm5.4 0c0.2 0 0.3 0.1 0.4 0.2l2.9-2.8c-0.9-0.9-2.1-1.4-3.3-1.4zm2.6 0.7h-2zm-2 0v2.6h4v-2.6zm2 4.6h5.4v-4h-5.4zm5.4 0c0.2 0 0.3 0.1 0.4 0.2l2.9-2.8c-0.9-0.9-2.1-1.4-3.3-1.4zm2.6 0.7h-2zm-2 0v14.7h4v-14.7zm0 14.7c0 0.2 0 0.3-0.2 0.4l2.9 2.9c0.9-0.9 1.3-2.1 1.3-3.3zm-0.6 2.6v-2zm0-2h-21.4v4h21.4zm-21.4 1.4h21.4v-4h-21.4zm23.4-2v-14.7h-4v14.7zm-2-16.7h-21.4v4h21.4zm-23.4 2v14.7h4v-14.7zm10-0.7h5.4v-4h-5.4zm7.4-2v-2.6h-4v2.6zm-2-4.6h-5.4v4h5.4zm-7.4 2v2.6h4v-2.6z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRole);
export default __webpack_public_path__ + "static/media/role.bda15ed21e785f45b5f7bd3f2edf584d.svg";
export { ForwardRef as ReactComponent };